import type { ApiResponse, DeviceModel } from '@packages/shared-types';

import { apiClient } from '@/services/apiClient';

export type CreateDeviceModelPayload = {
  name: string;
  manufacturer?: string;
  slug: string;
  features: Record<string, boolean>;
};

export type UpdateDeviceModelPayload = {
  name?: string;
  manufacturer?: string;
  slug?: string;
  features?: Record<string, boolean>;
};

export async function listDeviceModels(): Promise<DeviceModel[]> {
  const response = await apiClient.get<ApiResponse<DeviceModel[]>>(
    '/api/device-models',
  );
  return response.data.data;
}

export async function getDeviceModelById(id: string): Promise<DeviceModel> {
  const response = await apiClient.get<ApiResponse<DeviceModel>>(
    `/api/device-models/${id}`,
  );
  return response.data.data;
}

export async function createDeviceModel(
  payload: CreateDeviceModelPayload,
): Promise<DeviceModel> {
  const response = await apiClient.post<ApiResponse<DeviceModel>>(
    '/api/device-models',
    payload,
  );
  return response.data.data;
}

export async function updateDeviceModel(
  id: string,
  payload: UpdateDeviceModelPayload,
): Promise<DeviceModel> {
  const response = await apiClient.put<ApiResponse<DeviceModel>>(
    `/api/device-models/${id}`,
    payload,
  );
  return response.data.data;
}

export async function deleteDeviceModel(id: string): Promise<void> {
  await apiClient.delete<ApiResponse<void>>(`/api/device-models/${id}`);
}
